import { Markdown, renderInline } from "./Markdown";

const ICON_START = /^\p{Extended_Pictographic}/u;
const MAX_TITLE = 90;

// La respuesta empieza con una línea-TÍTULO con ícono («✅ Cambio aplicado y verificado»): se muestra como título, sin caja, y lo demás como Markdown (párrafos, tablas, listas).
// Un resumen viejo (sin ícono al inicio) se muestra completo como texto normal, también sin caja.
export function splitSummary(text) {
  const src = String(text ?? "").replace(/\r\n/g, "\n").trim();
  const nl = src.indexOf("\n");
  const first = (nl === -1 ? src : src.slice(0, nl)).trim();
  if (ICON_START.test(first) && first.length <= MAX_TITLE) return { title: first, body: nl === -1 ? "" : src.slice(nl + 1).trim() };
  return { title: "", body: src };
}

export function SummaryBlock({ text }) {
  const { title, body } = splitSummary(text);
  return (
    <div data-testid="message-summary" className="mb-4 break-words">
      {title && (
        <h2 data-testid="message-title" className="text-2xl font-semibold leading-8 tracking-[-0.025em] text-foreground/95 mb-1">
          {renderInline(title, "t")}
        </h2>
      )}
      {body && (
        <div className="text-base leading-7 text-foreground/80">
          <Markdown text={body} />
        </div>
      )}
    </div>
  );
}
